// ScenarioEditor.tsx — mode toggle (Prognose/Backtest) + the mode-specific fields.
import { ForecastFields } from './ForecastFields.js';
import { BacktestFields } from './BacktestFields.js';
import type { ScenarioState } from '../lib/scenario.js';
import type { FundInfo } from '../lib/types.js';

export interface ScenarioEditorProps {
  scenario: ScenarioState;
  onChange: (scenario: ScenarioState) => void;
  funds: FundInfo[];
  fundsLoading?: boolean | undefined;
  fundsError?: string | null | undefined;
}

export function ScenarioEditor({ scenario, onChange, funds, fundsLoading, fundsError }: ScenarioEditorProps) {
  return (
    <div>
      <div class="field">
        <span class="field-label">Modus</span>
        <div class="segmented" role="group" aria-label="Modus">
          <button
            type="button"
            class="chip"
            aria-pressed={scenario.mode === 'forecast'}
            onClick={() => onChange({ ...scenario, mode: 'forecast' })}
          >
            Prognose
          </button>
          <button
            type="button"
            class="chip"
            aria-pressed={scenario.mode === 'backtest'}
            onClick={() => onChange({ ...scenario, mode: 'backtest' })}
          >
            Backtest
          </button>
        </div>
      </div>

      {scenario.mode === 'forecast' ? (
        <ForecastFields
          form={scenario.forecast}
          onChange={(forecast) => onChange({ ...scenario, forecast })}
          funds={funds}
          fundsLoading={fundsLoading}
          fundsError={fundsError}
        />
      ) : (
        <BacktestFields
          form={scenario.backtest}
          onChange={(backtest) => onChange({ ...scenario, backtest })}
          funds={funds}
          fundsLoading={fundsLoading}
          fundsError={fundsError}
        />
      )}
    </div>
  );
}
